<template>
  <empty-page></empty-page>
</template>

<script lang="ts">
import Vue from 'vue';
import { AppNavigation } from '@rready/integration';

export default Vue.extend({
  beforeRouteEnter() {
    const url = AppNavigation.authLogoutUrl();
    window.location.assign(url);
  }
});
</script>

<style lang="css" scoped></style>
